import { Campaign2Service } from './../../../services/campaign-2.0/campaign2.service';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-campaign-touchpoints',
  templateUrl: './campaign-touchpoints.component.html',
  styleUrls: ['./campaign-touchpoints.component.css', '../coupon-setup.scss']
})
export class CampaignTouchpointsComponent implements OnInit {
  tpToShow: any;
  touchpoints: any[] = [];
  touchpointsOnline: any[] = [];
  selectedTouchpoints: string[] = [];
  prioritiesTouchpointOnline: any[] = [];
  @Input() actionId: string;
  @Input() messageInstanceId: string;
  @Input() scope: string;
  @Input() invalidSubmit: boolean;
  @Input() tpWithoutStores: number[];
  @Input() disableTouchpoint: boolean;
  @Input() actionTypeCode: string;
  @Output() onTpSet: EventEmitter<any> = new EventEmitter;
  @Output() tpSelected: EventEmitter<any> = new EventEmitter;
  @Output() tpOnline: EventEmitter<any> = new EventEmitter;
  @Output() tpSetOnline: EventEmitter<any> = new EventEmitter;

  constructor(
    private campaignService: Campaign2Service
  ) { }

  ngOnInit() {
    this.setTouchpoints();
  }

  setTouchpoints() {
    const couponScope = this.scope[0].toUpperCase();
    const couponActionTypeCode = this.actionTypeCode[0].toUpperCase();
    this.campaignService.getTouchPoints(couponScope, couponActionTypeCode).subscribe(touchpoints => {
      if (touchpoints && touchpoints.length > 0) { // da aggiungere controllo per ottenere solo touchpoint offline 1
        if (this.scope === 'emission') {
          touchpoints.forEach(tp => {
            if (tp.flg_offline === '1') {
              this.touchpoints.push({
                label: tp.description,
                value: tp.id,
                stores: [],
                storesId: [],
                groupId: '',
                flg_offline: tp.flg_offline
                });
            } else {
              this.touchpointsOnline.push({
                label: tp.description,
                value: tp.id,
                stores: [],
                storesId: [],
                groupId: '',
                flg_offline: tp.flg_offline
                });
            }
        });
        this.tpOnline.emit(this.touchpointsOnline);
        } else {
          touchpoints.forEach(tp => {
              this.touchpoints.push({
                label: tp.description,
                value: tp.id,
                stores: [],
                storesId: [],
                groupId: '',
                flg_offline: tp.flg_offline
                });
        });
      }
    }
      if (this.actionId) {
        this.campaignService.getChannelPriorities(this.actionId, this.scope).subscribe(channels => {
          if (channels && channels.length > 0) {
            this.selectedTouchpoints = [];
            if (this.scope === 'emission') {
              channels.sort((a, b) => (a.priority > b.priority) ? 1 : -1);
              channels.forEach(c => {
                if (c.priority !== -99) {
                  let tp = this.touchpointsOnline.find(t => t.value === c.ochannel_id);
                  this.prioritiesTouchpointOnline.push(tp);
                }
              })
              this.tpSetOnline.emit(this.prioritiesTouchpointOnline);
            }
            channels.forEach((channel, i) => {
              //if (channel.priority === -99) {
                this.selectedTouchpoints.push(channel.ochannel_id.toString());
              //}
            });
            this.setStores();
            this.onTpSet.emit({
              touchpoints: this.touchpoints,
              selectedTouchpoints: this.selectedTouchpoints,
              channels: channels
            });
          } else {
            this.onTpSet.emit({
              touchpoints: this.touchpoints,
              selectedTouchpoints: this.selectedTouchpoints
            });
          }
        });
      }
    });
  }

  setStores() {
    const filters = {
      insegna: [],
      area: [],
      gruppo: '',
      codici: []
    };
    this.campaignService.getStoresFromFilters(filters).subscribe(stores => {
      this.selectedTouchpoints.forEach(stpId => {
        this.campaignService.getTouchpointStores(+this.messageInstanceId, stpId, this.scope).subscribe(tpStores => {
          if (tpStores && tpStores.length > 0) {
            tpStores.forEach(tps => {
              const tpToEdit = this.touchpoints.filter(tp => tp.value === +stpId)[0];
              const filteredStore = stores.filter(store => store.id === tps.store_id)[0];
              if (filteredStore) {
                tpToEdit['stores'].push(filteredStore);
              }
              tpToEdit['storesId'].push(tps.store_id.toString());
            });
          }
        });
      });
    });
  }

  onTouchpointSelection(event, tp) {
    console.log(event, tp);
    if (event && tp.flg_offline === '1') {
      this.tpToShow = tp;
    } else {
      this.tpToShow = null;
    }
    tp.stores = tp.storesId = [];
    tp.groupId = '';
    this.tpSelected.emit({
      flgSelected: event,
      selectedTp: tp,
      selectedTouchpoints: this.selectedTouchpoints
    })
  }

  showTpDetails(touchpoint: any) {
    if (this.tpToShow === touchpoint) {
      this.tpToShow = null;
    } else {
      this.tpToShow = touchpoint;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/campaign-touchpoints/campaign-touchpoints.component.ts